/* Caipi Redesign — Aussaatkalender Builder. Liest die Sorten/Kategorien (JSON
   aus der Section, Monate = echte Metafeld-Listen), baut Picker + Tag-Leiste +
   Live-12-Monats-Kalender. Persistenz via localStorage, „Als PDF" via Druck. */
(function () {
  'use strict';

  var MONTHS = ['J', 'F', 'M', 'A', 'M', 'J', 'J', 'A', 'S', 'O', 'N', 'D'];
  var MONTHS_ABBR = ['Jan', 'Feb', 'Mär', 'Apr', 'Mai', 'Jun', 'Jul', 'Aug', 'Sep', 'Okt', 'Nov', 'Dez'];
  var MONTHS_FULL = ['Januar', 'Februar', 'März', 'April', 'Mai', 'Juni', 'Juli', 'August', 'September', 'Oktober', 'November', 'Dezember'];
  var NM = { 'januar': 1, 'februar': 2, 'märz': 3, 'maerz': 3, 'april': 4, 'mai': 5, 'juni': 6, 'juli': 7, 'august': 8, 'september': 9, 'oktober': 10, 'november': 11, 'dezember': 12 };
  var LS_KEY = 'rdKal:v1';

  function toNums(arr) { return (arr || []).map(function (s) { return NM[String(s).trim().toLowerCase()]; }).filter(Boolean); }
  function esc(s) { return String(s == null ? '' : s).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;').replace(/'/g, '&#39;'); }
  function hasM(set) { return set && set.length > 0; }
  function inM(set, m) { return set && set.indexOf(m) > -1; }
  function mLabel(n) { return MONTHS_ABBR[(n - 1 + 12) % 12]; }
  function runs(set) {
    if (!set || !set.length) return [];
    var s = set.slice().sort(function (a, b) { return a - b; });
    var out = [], start = s[0], prev = s[0];
    for (var i = 1; i < s.length; i++) { if (s[i] === prev + 1) { prev = s[i]; } else { out.push([start, prev]); start = s[i]; prev = s[i]; } }
    out.push([start, prev]); return out;
  }
  function runLabel(set) { return runs(set).map(function (r) { return r[0] === r[1] ? mLabel(r[0]) : mLabel(r[0]) + '–' + mLabel(r[1]); }).join(', '); }

  function initRoot(root) {
    if (root.dataset.rdKalInit === '1') return;
    root.dataset.rdKalInit = '1';

    var dataEl = root.querySelector('[data-rd-kal-data]');
    var RAW = [];
    try { RAW = JSON.parse(dataEl.textContent) || []; } catch (e) { RAW = []; }
    var ENTRIES = RAW.map(function (e) {
      return { id: e.id, label: e.label, group: e.group, color: e.color, url: e.url || '', sow: toNums(e.sow), plant: toNums(e.plant), harvest: toNums(e.harvest) };
    }).filter(function (e) { return hasM(e.sow) || hasM(e.plant) || hasM(e.harvest); });
    if (!ENTRIES.length) return;

    var byId = {};
    ENTRIES.forEach(function (e) { byId[e.id] = e; });
    var groupOrder = [], groups = {};
    ENTRIES.forEach(function (e) { if (!groups[e.group]) { groups[e.group] = []; groupOrder.push(e.group); } groups[e.group].push(e); });
    function groupColor(g) { return (groups[g] && groups[g][0] && groups[g][0].color) || 'var(--rd-sage)'; }

    var now = new Date();
    var curMonth = now.getMonth() + 1;

    var selected, isDefault = false;
    function load() {
      var raw = null;
      try { raw = window.localStorage.getItem(LS_KEY); } catch (e) {}
      if (raw) { try { var arr = JSON.parse(raw); if (Array.isArray(arr)) { selected = arr; isDefault = false; return; } } catch (e) {} }
      selected = ENTRIES.filter(function (e) { return inM(e.sow, curMonth) || inM(e.plant, curMonth); }).slice(0, 6).map(function (e) { return e.id; });
      isDefault = true;
    }
    function persist() { try { window.localStorage.setItem(LS_KEY, JSON.stringify(selected)); } catch (e) {} }
    function mutate(fn) { if (isDefault) isDefault = false; fn(); persist(); renderAll(); }
    function isSel(id) { return selected.indexOf(id) > -1; }
    function add(id) { if (!isSel(id)) mutate(function () { selected.push(id); }); }
    function remove(id) { mutate(function () { selected = selected.filter(function (x) { return x !== id; }); }); }
    function toggle(id) { isSel(id) ? remove(id) : add(id); }
    function clearAll() { mutate(function () { selected = []; }); }

    function groupSchedule(g) {
      var es = groups[g] || [];
      function uni(key) { var s = {}; es.forEach(function (e) { e[key].forEach(function (m) { s[m] = 1; }); }); return Object.keys(s).map(Number); }
      return { sow: uni('sow'), plant: uni('plant'), harvest: uni('harvest') };
    }
    function resolve(id) {
      if (id.indexOf('grp:') === 0) {
        var g = id.slice(4);
        if (!groups[g]) return null;
        return { id: id, label: 'Alle ' + g, color: groupColor(g), source: isDefault ? 'seasonal' : 'group', sched: groupSchedule(g) };
      }
      var e = byId[id];
      if (!e) return null;
      return { id: id, label: e.label, color: e.color, source: isDefault ? 'seasonal' : 'manual', sched: { sow: e.sow, plant: e.plant, harvest: e.harvest } };
    }
    function activeTags() { return selected.map(resolve).filter(Boolean); }

    var pickerEl = root.querySelector('[data-rd-kal-picker]');
    var tagsEl = root.querySelector('[data-rd-kal-tags]');
    var calEl = root.querySelector('[data-rd-kal-cal]');
    var countEls = root.querySelectorAll('[data-rd-kal-tagcount]');
    var clearBtn = root.querySelector('[data-rd-kal-clear]');
    var banner = root.querySelector('[data-rd-kal-banner]');
    var saveBtn = root.querySelector('[data-rd-kal-save]');
    var pdfBtn = root.querySelector('[data-rd-kal-pdf]');
    var printDate = root.querySelector('[data-rd-kal-printdate]');

    var openGroups = {};
    groupOrder.forEach(function (g, i) { openGroups[g] = (i === 0); });

    function chevSvg() { return '<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"><path d="M6 9l6 6 6-6"/></svg>'; }
    function checkSvg() { return '<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.6" stroke-linecap="round" stroke-linejoin="round"><path d="M20 6L9 17l-5-5"/></svg>'; }
    function hint(e) {
      var parts = [];
      if (hasM(e.sow)) parts.push('Vorkultur ' + runLabel(e.sow));
      if (hasM(e.plant)) parts.push('Aussaat ' + runLabel(e.plant));
      if (hasM(e.harvest)) parts.push('Ernte ' + runLabel(e.harvest));
      return parts.join(' · ');
    }
    function buildPicker() {
      var html = '';
      groupOrder.forEach(function (g) {
        var es = groups[g], col = groupColor(g);
        html += '<div class="rd-kal__grp" data-grp="' + esc(g) + '">'
          + '<button type="button" class="rd-kal__grp-head" data-grp-toggle="' + esc(g) + '">'
          + '<span class="rd-kal__grp-bar" style="background:' + esc(col) + '"></span>'
          + '<span class="rd-kal__grp-name">' + esc(g) + '</span>'
          + '<span class="rd-kal__grp-n">' + es.length + '</span>'
          + '<span class="rd-kal__grp-chev" aria-hidden="true">' + chevSvg() + '</span></button>'
          + '<div class="rd-kal__grp-body">'
          + '<button type="button" class="rd-kal__grpadd" data-add="grp:' + esc(g) + '"><span class="rd-kal__grpadd-ico">+</span> Alle ' + esc(g) + ' in den Kalender</button>';
        es.forEach(function (e) {
          html += '<div class="rd-kal__opt" data-opt="' + esc(e.id) + '">'
            + '<span class="rd-kal__opt-bar" style="background:' + esc(e.color) + '"></span>'
            + '<span class="rd-kal__opt-body"><span class="rd-kal__opt-l">' + esc(e.label) + '</span>'
            + '<span class="rd-kal__opt-hint">' + esc(hint(e)) + '</span></span>'
            + '<button type="button" class="rd-kal__opt-btn" data-toggle="' + esc(e.id) + '" aria-label="Hinzufügen">'
            + '<span class="rd-kal__opt-add">+</span><span class="rd-kal__opt-check">' + checkSvg() + '</span></button></div>';
        });
        html += '</div></div>';
      });
      pickerEl.innerHTML = html;
    }
    function syncPickerState() {
      [].forEach.call(pickerEl.querySelectorAll('.rd-kal__grp'), function (gEl) { gEl.classList.toggle('is-open', !!openGroups[gEl.getAttribute('data-grp')]); });
      [].forEach.call(pickerEl.querySelectorAll('.rd-kal__opt'), function (o) { o.classList.toggle('is-active', isSel(o.getAttribute('data-opt'))); });
      [].forEach.call(pickerEl.querySelectorAll('.rd-kal__grpadd'), function (b) { b.classList.toggle('is-active', isSel(b.getAttribute('data-add'))); });
    }

    function renderTags() {
      var tags = activeTags();
      tagsEl.innerHTML = tags.map(function (t) {
        var dot = (t.source === 'group')
          ? '<span class="rd-kal__tag-dot rd-kal__tag-dot--group"></span>'
          : '<span class="rd-kal__tag-dot" style="background:' + esc(t.color) + (t.source === 'seasonal' ? ';opacity:.65' : '') + '"></span>';
        return '<button type="button" class="rd-kal__tag rd-kal__tag--' + t.source + '" data-remove="' + esc(t.id) + '">' + dot + esc(t.label) + '<span class="rd-kal__tag-x" aria-hidden="true">×</span></button>';
      }).join('') || '<p class="rd-kal__tags-empty">Noch keine Sorten gewählt — tippe oben auf „+".</p>';
      var n = tags.length;
      [].forEach.call(countEls, function (c) { c.textContent = n; });
      if (clearBtn) clearBtn.hidden = n === 0;
      if (banner) {
        banner.hidden = !(isDefault && n > 0);
        if (!banner.hidden) {
          var eye = banner.querySelector('[data-rd-kal-banner-eye]');
          var sub = banner.querySelector('[data-rd-kal-banner-h]');
          if (eye) eye.textContent = 'Vorschau · ' + MONTHS_FULL[curMonth - 1];
          if (sub) sub.textContent = 'Das säen Gärtner im ' + MONTHS_FULL[curMonth - 1];
        }
      }
    }

    function barsHtml(set, color, kind) {
      return runs(set).map(function (r) {
        var left = (r[0] - 1) / 12 * 100, width = (r[1] - r[0] + 1) / 12 * 100;
        return '<span class="rd-kal__cal-bar rd-kal__cal-bar--' + kind + '" style="left:' + left + '%;width:' + width + '%;background:' + esc(color) + '"></span>';
      }).join('');
    }
    function renderCal() {
      var tags = activeTags();
      var head = '<div class="rd-kal__cal-row rd-kal__cal-head"><div class="rd-kal__cal-lbl"></div><div class="rd-kal__cal-months">';
      for (var m = 1; m <= 12; m++) head += '<span class="rd-kal__cal-m' + (m === curMonth ? ' is-now' : '') + '" title="' + MONTHS_FULL[m - 1] + '">' + MONTHS[m - 1] + '</span>';
      head += '</div></div>';
      var rows = tags.map(function (t) {
        var s = t.sched;
        var bars = barsHtml(s.sow, t.color, 'sow') + barsHtml(s.plant, t.color, 'plant') + barsHtml(s.harvest, t.color, 'harvest');
        var nowLine = '<span class="rd-kal__cal-now" style="left:' + (((curMonth - 1) / 12 * 100) + (1 / 24 * 100)) + '%"></span>';
        var srcLabel = t.source === 'group' ? 'Gruppe' : (t.source === 'seasonal' ? 'Vorschlag' : 'Sorte');
        return '<div class="rd-kal__cal-row"><div class="rd-kal__cal-lbl"><span class="rd-kal__cal-name">' + esc(t.label) + '</span><span class="rd-kal__cal-src">' + srcLabel + '</span></div>'
          + '<div class="rd-kal__cal-track">' + bars + nowLine + '</div></div>';
      }).join('');
      if (!tags.length) rows = '<p class="rd-kal__cal-empty">Wähle oben Sorten oder eine Gruppe, um deinen Jahresplan zu sehen.</p>';
      calEl.innerHTML = head + rows;
    }

    function renderAll() { syncPickerState(); renderTags(); renderCal(); }

    pickerEl.addEventListener('click', function (e) {
      var tgl = e.target.closest('[data-grp-toggle]');
      if (tgl) { var g = tgl.getAttribute('data-grp-toggle'); openGroups[g] = !openGroups[g]; syncPickerState(); return; }
      var addG = e.target.closest('[data-add]'); if (addG) { toggle(addG.getAttribute('data-add')); return; }
      var t = e.target.closest('[data-toggle]'); if (t) { toggle(t.getAttribute('data-toggle')); return; }
    });
    tagsEl.addEventListener('click', function (e) { var r = e.target.closest('[data-remove]'); if (r) remove(r.getAttribute('data-remove')); });
    if (clearBtn) clearBtn.addEventListener('click', clearAll);
    if (saveBtn) saveBtn.addEventListener('click', function () { if (isDefault) { isDefault = false; persist(); renderAll(); } else persist(); toast('Kalender gespeichert ✓'); });
    if (pdfBtn) pdfBtn.addEventListener('click', function () { if (printDate) printDate.textContent = now.toLocaleDateString('de-DE', { day: '2-digit', month: 'long', year: 'numeric' }); window.print(); });

    function toast(msg) {
      var t = document.createElement('div'); t.className = 'rd-kal__toast'; t.textContent = msg; document.body.appendChild(t);
      requestAnimationFrame(function () { t.classList.add('is-on'); });
      setTimeout(function () { t.classList.remove('is-on'); setTimeout(function () { t.remove(); }, 300); }, 1800);
    }

    load(); buildPicker(); renderAll();
  }

  function init() {
    document.querySelectorAll('[data-rd-kal]').forEach(function (root) {
      try { initRoot(root); } finally { root.removeAttribute('data-rd-kal-pending'); }
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  document.addEventListener('shopify:section:load', init);
})();
